import * as React from "react";

type Props = {
    header?: string;
    tabUniqueKey?: string;
    leftIcon?: string;
    rightIcon?: string;
    disabled?: boolean;
    headerStyle?: any;
    headerClassName?: string;
    contentStyle?: any;
    contentClassName?: string;
    children: any;
};

type State = {
};

/**
 * TabPanel component
 *
 * @since 0.0.1
 * @author Jongkwang Park
 * @class
 */
export class Tab extends React.Component {

    /* for React */
    props: Props;
    state: State;

    static defaultProps = {
    };

    constructor(props?: Props) {
        super(props);
    }
}
